export default [
    {
        path: "/calendar",
        name: "calendar",
        component: require("../components/modules/calendar/CalendarGrid.vue")
            .default
    }
];
